































































































































































































































































































































import { EditorHelper, NodeType } from '@getaccept/editor-lib';
import type { PartiallySignedEvent } from '@getaccept/editor-lib/src/types/signed-field';
import {
  EditorViewInputAction,
  namespace,
} from '@getaccept/editor-view/src/store/editor-view-input.constants';
import { editorViewInputState } from '@getaccept/editor-view/src/store/editor-view-input.store';
import { editorViewStore } from '@getaccept/editor-view/src/store/editor-view.store';
import { AttachmentType } from '@getaccept/lib-shared/src/attachments/types/attachment-type';
import type { ChatComment } from '@getaccept/lib-shared/src/chat/types/chat-comment';
import ThemedButton from '@getaccept/lib-shared/src/components/ThemedButton.vue';
import type { Entity as IEntity } from '@getaccept/lib-shared/src/entity/signing-site/types/entity';
import { DocumentStatus } from '@getaccept/lib-shared/src/enums/document-status';
import { WindowSize } from '@getaccept/lib-shared/src/enums/window-size';
import { FieldHelper } from '@getaccept/lib-shared/src/fields/helpers/field.helper';
import { FieldType } from '@getaccept/lib-shared/src/fields/types/enums/field-type';
import type { Field } from '@getaccept/lib-shared/src/fields/types/field';
import { throttle } from '@getaccept/lib-shared/src/helpers';
import { isWindowSize } from '@getaccept/lib-shared/src/helpers/window-size.helper';
import type { Integration } from '@getaccept/lib-shared/src/integrations/types/integration';
import PromptBar from '@getaccept/lib-shared/src/prompt-bar/PromptBar.vue';
import ReviewChangesModal from '@getaccept/lib-shared/src/prompt-bar/ReviewChangesModal.vue';
import RevisionPromptBar from '@getaccept/lib-shared/src/prompt-bar/RevisionPromptBar.vue';
import { RecipientRole } from '@getaccept/lib-shared/src/recipients/types/enums/recipient-role';
import { RecipientStatus } from '@getaccept/lib-shared/src/recipients/types/enums/recipient-status';
import { SigningHelper as SigningShared } from '@getaccept/lib-shared/src/signature/helpers/signing.helper';
import { BrandingHelper } from '@getaccept/lib-shared/src/signing-theme/helpers/branding.helper';
import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import { useToast } from '@getaccept/lib-shared/src/toast';
import type { NodeTrackingPayload } from '@getaccept/lib-shared/src/tracking/types/node-tracking-payload';
import { TrackingType } from '@getaccept/lib-shared/src/tracking/types/tracking-type';
import type { DocumentAttachment } from '@getaccept/lib-shared/src/types/document-attachment';
import type { DocumentPage } from '@getaccept/lib-shared/src/types/document-page';
import type { DocumentRecipientRevision } from '@getaccept/lib-shared/src/types/document-revision';
import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import type { ManuallySignedPage } from '@getaccept/lib-shared/src/types/manually-signed-page';
import type { SigningPageDocument as IDocument } from '@getaccept/lib-shared/src/types/signing-page-document';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { SigningPageVideo } from '@getaccept/lib-shared/src/types/signing-page-video';
import EngageVideo from '@getaccept/lib-shared/src/video/player/components/EngageVideo.vue';
import type { Channel } from '@getaccept/pusher';
import { ChannelType, PusherEvent } from '@getaccept/pusher';
import printJS from 'print-js';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import TrackingService from '../api/tracking/services/tracking.service';
import type { AuthenticationStepInput } from '../authentication/types/authentication-step-input';
import Chat from '../chat/components/Chat.vue';
import { ChatAction, ChatGetter, ChatNamespace } from '../chat/store/chat.constants';
import { isPopupBlocked } from '../common/utils/window';
import DocumentHeader from '../documents/components/DocumentHeader.vue';
import MainMenu from '../documents/components/MainMenu.vue';
import { documentOptions } from '../documents/constants/document-options';
import { reviewTimerDuration } from '../documents/constants/review-timer-duration';
import {
  Document,
  DocumentAction as EDocumentAction,
  DocumentGetter,
} from '../documents/store/document.constants';
import type { DocumentOption } from '../documents/types/document-option';
import { DocumentEvent } from '../documents/types/enums/document-event';
import { SidebarOptionType } from '../documents/types/enums/sidebar-option-type';
import { Entity } from '../entity/store/entity.constants';
import type { EntityState } from '../entity/store/entity.types';
import { FieldAction, FieldGetter, Fields } from '../fields/store/field.constants';
import { PageHelper } from '../helpers/page.helper';
import { RevisionHelper } from '../helpers/revision.helper';
import AuthorizeNet from '../integrations/authorizenet/components/AuthorizeNet.vue';
import {
  actionLoadAuthorizeNet,
  actionLoadStripe,
} from '../integrations/store/integrations.actions';
import Stripe from '../integrations/stripe/components/Stripe.vue';
import PhoneModal from '../integrations/twilio/components/PhoneModal.vue';
import LobbyCard from '../lobby/components/LobbyCard.vue';
import { pusherClient } from '../pusher';
import RecipientsModal from '../recipients/components/RecipientsModal.vue';
import { Session } from '../session/store/session.constants';
import type { SessionState } from '../session/store/session.types';
import { SessionAction } from '../session/store/session.types';
import BottomBar from '../signing/components/BottomBar.vue';
import DocumentAction from '../signing/components/DocumentAction.vue';
import DocumentContainer from '../signing/components/DocumentContainer.vue';
import DocumentUpdatedPromptBar from '../signing/components/DocumentUpdatedPromptBar.vue';
import DownloadingPromptBar from '../signing/components/DownloadingPromptBar.vue';
import ApproveModal from '../signing/components/modals/ApproveModal.vue';
import InitialsModal from '../signing/components/modals/InitialsModal.vue';
import InviteModal from '../signing/components/modals/InviteModal.vue';
import RejectModal from '../signing/components/modals/RejectModal.vue';
import SignModal from '../signing/components/modals/SignModal.vue';
import SignActions from '../signing/components/SignActions.vue';
import SigningOptions from '../signing/components/SigningOptions.vue';
import TopBar from '../signing/components/TopBar.vue';
import UnsupportedBrowserModal from '../signing/components/UnsupportedBrowserModal.vue';
import { SigningHelper } from '../signing/helpers/signing.helper';
import { Signing as SigningModule, SigningAction } from '../signing/store/signing.constants';
import type { BankId } from '../signing/types/bankid';
import type { Id } from '../signing/types/eid';
import type { CriiptoStatus } from '../signing/types/enums/criipto-status';
import { SigningStep as ESigningStep } from '../signing/types/enums/signing-step';
import type { InviteRecipientInfo } from '../signing/types/invite-recipient-info';
import type { SigningStep } from '../signing/types/signing-step';
import UploadAttachmentModal from '../signing/upload-attachment/components/UploadAttachmentModal.vue';
import type { RootState } from '../store/root.types';
import { RootAction } from '../store/root.types';
import * as supportedBrowsersRegExp from '../supported-browsers-reg-exp.js';
import { Theme } from '../theme/store/theme.constants';
import { TrackingHelper } from '../tracking/helpers/tracking.helper';
import TrackVisitTimes from '../tracking/components/TrackVisitTimes.vue';
import VideoReminder from '../video/components/VideoReminder.vue';
import { TrackingConstants } from '../tracking/constants/tracking';
import CommentHistoryContainer from '../signing/components/CommentHistoryContainer.vue';
import type { DocumentState } from '../documents/store/document.types';

@Component({
  components: {
    Chat,
    CommentHistoryContainer,
    TopBar,
    DocumentAction,
    DocumentHeader,
    BottomBar,
    ThemedButton,
    SignActions,
    UnsupportedBrowserModal,
    DocumentContainer,
    RecipientsModal,
    MainMenu,
    EngageVideo,
    SigningOptions,
    LobbyCard,
    RejectModal,
    SignModal,
    ApproveModal,
    InviteModal,
    Stripe,
    AuthorizeNet,
    PhoneModal,
    VideoReminder,
    InitialsModal,
    ReviewChangesModal,
    PromptBar,
    DownloadingPromptBar,
    RevisionPromptBar,
    DocumentUpdatedPromptBar,
    UploadAttachmentModal,
    TrackVisitTimes,
  },
})
export default class Signing extends Vue {
  @State((state: RootState) => state.documentId) documentId: string;
  @State((state: RootState) => state.recipientId) recipientId: string;
  @State((state: RootState) => state.authId) authId: string;
  @State((state: RootState) => state.isPreview) isPreview: boolean;
  @State((state: RootState) => state.pusherConnected) pusherConnected: boolean;
  @Action(RootAction.SetIds) setIds: (payload: {
    signingPageId: string;
    recipientId?: string;
    authId: string;
    userId?: string;
    videoReminderId?: string;
  }) => void;
  @Action(RootAction.SetPreviewExpired) setPreviewExpired: (expired: boolean) => void;

  @Entity.State((state: EntityState) => state.entity) entity: IEntity;

  @State('authorizeNet', { namespace: 'integrations' }) authorizeNetIntegration: Integration;
  @State('stripe', { namespace: 'integrations' }) stripeIntegration: Integration;
  @Action(actionLoadStripe, { namespace: 'integrations' }) loadStripe: any;
  @Action(actionLoadAuthorizeNet, { namespace: 'integrations' }) loadAuthorizeNet: any;

  @Session.State((state: SessionState) => state.token) token: { jwt: string; exp: number };
  @Session.State((state: SessionState) => state.recipientFirstOpen)
  recipientFirstOpen: boolean;
  @Session.Action(SessionAction.SetRecipientFirstOpen) setRecipientFirstOpen: (
    value: boolean
  ) => void;
  @Session.Action(SessionAction.SetStatus) setSessionStatus: (status: DocumentStatus) => void;
  @Session.Action(SessionAction.LoadTokenSuccess) setToken: (payload: {
    token: {
      jwt: string;
      exp: number;
    };
    authStepsInput: AuthenticationStepInput[];
  }) => void;

  @SigningModule.State('initials') initials: string;
  @SigningModule.State('step') step!: SigningStep;
  @SigningModule.State('selectedInitialFieldId') selectedInitialFieldId: string;
  @SigningModule.State('bankId') bankId: BankId;
  @SigningModule.State('selectedEid') selectedEid: Id;
  @SigningModule.State('criiptoStatus') criiptoStatus: CriiptoStatus;
  @SigningModule.Action(SigningAction.RestartPoll) actionRestartPoll: (payload: {
    documentId: string;
    recipientId: string;
  }) => void;
  @SigningModule.Action(SigningAction.CancelBankIdTransaction) actionCancelBankIdTransaction: (
    ssn: string
  ) => void;
  @SigningModule.Action(SigningAction.ApproveDocument) actionApproveDocument: () => void;
  @SigningModule.Action(SigningAction.AddInitials) addInitials: (payload: {
    initials: string;
    fieldId: string;
  }) => void;
  @SigningModule.Action(SigningAction.SetSelectedInitialFieldId) setSelectedInitialFieldId: (
    selectedInitialFieldId: string
  ) => void;
  @SigningModule.Action(SigningAction.ResetState) resetSigningState: () => void;
  @SigningModule.Action(SigningAction.VerifySignature) verifySignature: any;
  @SigningModule.Action(SigningAction.CheckVerificationStep)
  checkVerificationStep: any;

  @ChatNamespace.State('comments') comments: ChatComment[];
  @ChatNamespace.State('isOpen') isChatOpen: boolean;
  @ChatNamespace.State('systemMessageOpen') chatSystemMessageOpen: boolean;
  @ChatNamespace.Action(ChatAction.LoadChat) actionLoadChat: () => void;
  @ChatNamespace.Action(ChatAction.AddComment) actionAddComment: (text: string) => void;
  @ChatNamespace.Action(ChatAction.AutoComment) actionAutoComment: () => void;
  @ChatNamespace.Action(ChatAction.SetIsOpen) actionSetIsChatOpen: (isChatOpen: boolean) => void;
  @ChatNamespace.Action(ChatAction.ReadComments) actionReadComments: () => void;
  @ChatNamespace.Action(ChatAction.SetSystemMessageOpen) actionSetChatSystemMessageOpen: (
    open: boolean
  ) => void;
  @ChatNamespace.Getter(ChatGetter.NumUnreadComments) numUnreadComments: number;

  @Document.State('isLoading') isLoading: boolean;
  @Document.State((state: DocumentState) => state.isEditorRecipientInputLoading)
  isEditorRecipientInputLoading: boolean;
  @Document.State('revisionsIsLoading') revisionsIsLoading: boolean;
  @Document.State('partiallySignedFields') partiallySignedFields: PartiallySignedEvent[];
  @Document.State('revisionsViewedLoading')
  revisionsViewedLoading: boolean;
  @Document.State('isButtonLoading') isButtonLoading: boolean;
  @Document.State('forwarded') forwarded: boolean;
  @Document.State('pdfUrl') pdfUrl: string;
  @Document.State('uploadingAttachmentIds')
  uploadingAttachmentIds: string[];
  @Document.State('isDownloading') isDownloading: boolean;
  @Document.State('focusedRequiredId') focusedRequiredId: string;
  @Document.State('document') document: IDocument;
  @Document.State('editorRecipientInput') editorRecipientInput: EditorRecipientInput[];
  @Document.Action(EDocumentAction.ForwardToRecipient)
  actionForwardToRecipient: any;
  @Document.Action(EDocumentAction.SetForwardStatus)
  actionSetForwardStatus: any;
  @Document.Action(EDocumentAction.SetFocusedRequiredId)
  setFocusedRequiredId: any;
  @Document.Action(EDocumentAction.SetRecipientStatus)
  setRecipientStatus: any;
  @Document.Action(EDocumentAction.SetAttachmentView)
  setAttachmentView: any;
  @Document.Action(EDocumentAction.SendDocumentStatus)
  sendDocumentStatus: any;
  @Document.Action(EDocumentAction.LoadAfterSign)
  actionLoadAfterSign: any;
  @Document.Action(EDocumentAction.RejectDocument)
  actionRejectDocument: any;
  @Document.Action(EDocumentAction.UpdateRecipients)
  actionUpdateRecipients: any;
  @Document.Action(EDocumentAction.LoadDocumentAttachments)
  actionLoadDocumentAttachments: () => Promise<void>;
  @Document.Action(EDocumentAction.SendEventLog) sendEventLog: any;
  @Document.Action(EDocumentAction.GetPdfUrl)
  actionGetPdfUrl: () => Promise<void>;
  @Document.Action(EDocumentAction.LoadDocument) loadDocument: any;
  @Document.Action(EDocumentAction.LoadDocumentRevisions)
  loadDocumentRevisions;
  @Document.Action(EDocumentAction.SetRevisionViewedByRecipient)
  setRevisionViewed;
  @Document.Action(EDocumentAction.LoadEditorRecipientInput)
  loadEditorRecipientInput;
  @Document.Action(EDocumentAction.LoadPartiallySignedFields)
  loadPartiallySignedFields;
  @Document.Action(EDocumentAction.DownloadDocument)
  actionDownload: any;
  @Document.Action(EDocumentAction.DownloadDocumentComplete)
  actionDownloadComplete: any;
  @Document.Action(EDocumentAction.SetEditorRecipientInput) actionSetEditorRecipientInput: (
    editorRecipientInput: EditorRecipientInput[]
  ) => void;
  @Document.Action(EDocumentAction.SetDocumentStatus) setDocumentStatus: (
    status: DocumentStatus
  ) => void;
  @Document.Getter(DocumentGetter.RecipientsTurnToSign)
  recipientsTurnToSign: SigningPageRecipient;
  @Document.Getter(DocumentGetter.MyTurnToSign)
  myTurnToSign: boolean;
  @Document.Getter(DocumentGetter.CurrentRecipient)
  currentRecipient: SigningPageRecipient;
  @Document.Getter(DocumentGetter.AreAttachmentsUploading)
  areAttachmentsUploading: boolean;
  @Document.Getter(DocumentGetter.VideoReminder)
  getterVideoReminder: SigningPageVideo;
  @Document.Getter(DocumentGetter.ViewableRecipients)
  viewableRecipients: SigningPageRecipient[];

  @Fields.State('pageWidth') pageWidth: number;
  @Fields.State('verifiedInitialFieldIds') verifiedInitialFieldIds: string[];
  @Fields.Action(FieldAction.Load) loadFields: any;
  @Fields.Action(FieldAction.UpdatePageWidth) updatePageWidth: any;
  @Fields.Action(FieldAction.UpdateValue) actionUpdateFieldValue: any;
  @Fields.Action(FieldAction.AddVerifiedInitialId) addVerifiedInitialFieldId: any;
  @Fields.Getter(FieldGetter.PositionedFields) fields: Field[];

  @Theme.State('theme') theme: SigningTheme;

  toast = useToast().toast;
  DocumentStatus = DocumentStatus;
  RecipientStatus = RecipientStatus;
  dimensionUpdateEmitted = false;
  isEngageVideoOpen = false;
  interactionTimer: any = null;
  entityIsLoaded = false;
  showRejectModal = false;
  pageImageLoaded = false;
  showBrowserPrompt = false;
  showMainMenu = false;
  uploadAttachmentData: { show: boolean; name: string; id: string } = {
    show: false,
    name: '',
    id: '',
  };
  showSigningModal = false;
  showInviteModal = false;
  showApproveModal = false;
  showStripeModal = false;
  showAuthorizeNetModal = false;
  showRecipientsModal = false;
  showPhoneModal = false;
  showVideoReminder = false;
  isPrinting = false;
  printFrame: HTMLIFrameElement;
  showReviewChangesModal = false;
  documentPusherChannel: Channel;
  recipientPusherChannel: Channel;
  showRevisionPromptBar = false;
  waitingToShowReviewModal = false;
  forcedReviewTimer = 20;
  showDocumentUpdatedPromptBar = false;
  debouncedResetInteractionTimer: () => void = throttle(() => this.resetInteractionTimer(), 1000);

  trackingDisabled = true;
  userIsInactive = false;
  pagesInViewport: DocumentPage[] = [];
  contextualCommentingDisabled = false;

  @Watch('document') async updateDocumentRevisions() {
    if (
      this.latestSealedRevision &&
      !this.latestSealedRevision.viewedByRecipient &&
      this.document?.documentRevisions?.length !== 1
    ) {
      if (!this.isPreview) {
        this.showReviewChangesModal = true;
        await this.setRevisionViewed(this.latestSealedRevision.revision);
      }
      await this.loadDocumentRevisions();
    }
  }

  @Watch('pusherConnected', { immediate: true })
  subscribePusher(pusherConnected: boolean) {
    if (pusherConnected) {
      this.addPusherSubscriptions();
    }
  }

  @Watch('currentRecipient')
  handleCurrentRecipient() {
    this.toggleTracking();
  }

  @Watch('document.status')
  handleDocumentStatus() {
    this.toggleTracking();
  }

  @Watch('numUnreadComments')
  handleWatchNumUnreadComments() {
    if (this.shouldPopChat) {
      this.handleToggleChat();
    } else if (this.isChatOpen) {
      this.actionReadComments();
    }
  }

  get shouldPopStripe(): boolean {
    return this.stripeIntegration && !!this.document.value;
  }

  commentHistoryOpen = false;

  get showCommentHistory(): boolean {
    return this.document && 'cc' in this.$route.query;
  }

  handleClickOutsideCommentHistory() {
    this.commentHistoryOpen = false;
  }

  toggleTracking(): void {
    if (
      TrackingHelper.allowedTrackingRecipientStatus(this.currentRecipient?.status) &&
      !this.isPreview &&
      this.document.status !== DocumentStatus.Signed
    ) {
      this.trackingDisabled = false;
    } else {
      this.trackingDisabled = true;
    }
  }

  async loadPreviewData() {
    await this.loadDocument(this.documentId);
    this.openEngageVideoAutomatic();
    this.loadFields();
  }

  handleReject(reason: string) {
    this.handleUpdateDocumentStatus(DocumentStatus.Rejected);
    this.actionRejectDocument({
      reason,
      recipientId: this.recipientId,
      documentId: this.document.id,
      authId: this.authId,
    });
  }

  handleUpdateDocumentStatus(status: DocumentStatus) {
    this.sendDocumentStatus({ newDocumentStatus: status });
  }

  get loadingRecipientInput(): boolean {
    return !!editorViewInputState.updatingInputs.length;
  }

  get showPromptBar(): boolean {
    return this.showRevisionPromptBar || this.isDownloading || this.showDocumentUpdatedPromptBar;
  }

  get shouldPopChat(): boolean {
    const smallScreen: boolean = isWindowSize(WindowSize.Small);
    return (
      this.numUnreadComments > 0 &&
      !this.isChatOpen &&
      !smallScreen &&
      this.comments.length === 1 &&
      this.isAutoComment
    );
  }

  get sortedAttachments(): DocumentAttachment[] {
    return [...this.document.documentAttachments].sort(
      (a: DocumentAttachment, b: DocumentAttachment) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
  }

  get viewportIsObscured(): boolean {
    return (
      (this.isChatOpen && isWindowSize(WindowSize.Small)) ||
      this.showEngageVideo ||
      this.showSigningModal ||
      this.showRecipientsModal ||
      this.showRejectModal ||
      this.showUploadAttachmentModal ||
      this.showApproveModal ||
      this.showMainMenu ||
      this.showPhoneModal ||
      this.showInviteModal ||
      this.showVideoReminder
    );
  }

  get signingActions(): DocumentOption[] {
    return documentOptions.filter((option: DocumentOption) => {
      if (option.type === SidebarOptionType.Call) {
        return this.activeTwilioIntegration;
      }
      if (option.type === SidebarOptionType.Download || option.type === SidebarOptionType.Print) {
        return this.documentExtractable;
      }
      if (option.type === SidebarOptionType.Invite) {
        return this.recipient?.role !== RecipientRole.Approver;
      }
      return true;
    });
  }

  get shouldStartEid(): boolean {
    return this.shouldStartCriipto || this.shouldStartBankId;
  }

  get shouldStartCriipto(): boolean {
    return !!this.criiptoStatus && !!this.selectedEid?.key;
  }

  get shouldStartBankId(): boolean {
    return !!this.bankId?.orderRef;
  }

  get chatEnabled(): boolean {
    return (
      this.entity &&
      !this.entity.isDisableComment &&
      this.recipient?.role !== RecipientRole.Approver
    );
  }

  get showLoader(): boolean {
    if (this.isPreview) {
      return this.isLoading;
    }
    return this.isLoading || this.isEditorRecipientInputLoading;
  }

  get documentExtractable(): boolean {
    return this.entity && !!this.entity.documentDownload;
  }

  get allRecipients(): SigningPageRecipient[] {
    return this.viewableRecipients;
  }

  get senderAvatarUrl(): string {
    if (!this.document || !this.document.user) {
      return '';
    }
    return this.document.user.thumbUrl;
  }

  get currentRecipientsTurnToSign(): boolean {
    return this.document && this.document.nextRecipientIdToSign === this.recipientId;
  }

  get documentPages(): DocumentPage[] {
    if (this.documentManuallySigned) {
      return [];
    }
    const mappedFields: Field[] = this.sortedFields.map((field: Field) =>
      SigningHelper.mappedFields(field, this.document, this.entity)
    );
    return PageHelper.getPagesWithFields(this.document.pages, mappedFields);
  }

  get documentManuallySigned(): boolean {
    return !!this.document?.manuallySignedPages?.length;
  }

  get manuallySignedPages(): ManuallySignedPage[] {
    if (this.documentManuallySigned) {
      return this.document.manuallySignedPages;
    }
    return [];
  }

  get recipient(): SigningPageRecipient {
    return this.allRecipients.find(
      (recipient: SigningPageRecipient) => recipient.id === this.recipientId
    );
  }

  get isSignActionAllowed(): boolean {
    if (this.isPreview || !this.recipient || !this.document?.isSigning) {
      return false;
    }
    return !SigningShared.hasRecipientSigned(this.recipient.status);
  }

  get videoUrl(): string {
    return this.document.video && this.document.video.videoUrl;
  }

  get videoId(): string {
    return this.document.video && this.document.video.id;
  }

  get videoThumbnail(): string {
    return this.document.video && this.document.video.thumbUrl;
  }

  get reminderExpirationDays(): number {
    return this.entity && this.entity.reminderExpirationDays;
  }

  get requiredStepsLeft(): boolean {
    return this.requiredIds && this.requiredIds.length > 0;
  }

  get requiredIds(): string[] {
    if (!this.isSignActionAllowed) {
      return [];
    }

    const requiredFields: Field[] = this.fields.filter(this.isRequiredField);
    const emptyRequiredEditorFields = EditorHelper.getEmptyFormFieldsAssignedToRecipient(
      EditorHelper.getEditorFormMergeFields(this.document.pages),
      EditorHelper.getAllRequiredEditorFields(this.document as any, [NodeType.Form]),
      this.editorRecipientInput,
      this.currentRecipient?.id
    );

    const emptyRequiredEditorSignatureFields = EditorHelper.getEmptySignatureFieldsAssignedToRecipient(
      EditorHelper.getAllRequiredEditorFields(this.document as any, [NodeType.Signature]),
      this.currentRecipient?.id,
      this.partiallySignedFields
    );
    const fieldsSortedByPosition: (Field & { pageNum: number })[] = FieldHelper.sortByPosition(
      requiredFields,
      this.documentPages
    );
    const requiredAttachments: DocumentAttachment[] = this.document.documentAttachments.filter(
      (attachment: DocumentAttachment) => {
        if (attachment.attachment.type === AttachmentType.Upload) {
          return attachment.requireView && !attachment.lastUpload;
        }
        return attachment.requireView && !attachment.lastView;
      }
    );
    const allEditorFields = EditorHelper.getAllRequiredEditorFields(this.document as any, [
      NodeType.Signature,
      NodeType.Form,
    ]);
    const sortedEmptyEditorFields = [
      ...emptyRequiredEditorFields,
      ...emptyRequiredEditorSignatureFields,
    ].sort(
      (a, b) =>
        allEditorFields.findIndex(field => field.id === a.id) -
        allEditorFields.findIndex(field => field.id === b.id)
    );

    const fieldsAndEditorFieldsSortedByPageNum = [
      ...fieldsSortedByPosition,
      ...sortedEmptyEditorFields,
    ].sort((a, b) => a.pageNum - b.pageNum);

    return [
      ...fieldsAndEditorFieldsSortedByPageNum.map(field => field.id),
      ...requiredAttachments.map((attachment: DocumentAttachment) => attachment.id),
    ];
  }

  isRequiredField(field: Field): boolean {
    if (field.recipientId !== this.recipientId) {
      return false;
    }
    const isEmptyInitialsField: boolean =
      field.type === FieldType.Initials && !this.verifiedInitialFieldIds.includes(field.id);

    const isEmptyRequiredField: boolean = !field.value && field.isRequired;

    return isEmptyRequiredField || isEmptyInitialsField || this.isInvalidFieldValue(field);
  }

  get nextRequiredId(): string {
    return (
      (this.requiredIds &&
        this.requiredIds[this.requiredIds.indexOf(this.focusedRequiredId) + 1]) ||
      this.requiredIds[0] ||
      null
    );
  }

  isInvalidFieldValue(field: Field): boolean {
    if (field.type === FieldType.Text && field.isRequired) {
      return !field.value?.trim();
    }
    if (field.type === FieldType.Formatted && field.value) {
      const validFieldValue: boolean =
        !!field.value.trim() && new RegExp(field.validationRegex).test(field.value);
      return !validFieldValue;
    }
    return false;
  }

  get sortedFields(): Field[] {
    return FieldHelper.sortByPosition(this.fields, this.document.pages) || [];
  }

  get activeTwilioIntegration(): boolean {
    return this.document && this.document.activeTwilioIntegration;
  }

  get documentLogo(): string {
    return BrandingHelper.getLogoUrl(this.theme);
  }

  get showEngageVideo(): boolean {
    if (!this.document || !this.document.isVideo) {
      return false;
    }
    return this.isEngageVideoOpen;
  }

  get showUploadAttachmentModal(): boolean {
    return this.uploadAttachmentData && this.uploadAttachmentData.show;
  }

  get isSigningEnabled(): boolean {
    return this.myTurnToSign;
  }

  get emptyBottomBar(): boolean {
    return this.isPreview || this.recipient.role === RecipientRole.CC;
  }

  get showReject(): boolean {
    return (
      !this.isPreview && this.isSigningEnabled && this.pageImageLoaded && !this.hasRecipientSigned
    );
  }

  get hasRecipientSigned(): boolean {
    return this.recipient.role === RecipientRole.Signer
      ? this.recipient.status === RecipientStatus.Signed
      : this.recipient.status === RecipientStatus.Approved;
  }

  get latestSealedRevision(): DocumentRecipientRevision {
    return RevisionHelper.getLatestSealedRevision(this.document?.documentRevisions);
  }

  get documentName(): string {
    return this.document?.name;
  }

  get senderFullName(): string {
    return this.document?.user?.fullName;
  }

  get reviewLoading(): boolean {
    return this.revisionsIsLoading || this.revisionsViewedLoading;
  }

  get reviewPending(): boolean {
    return (
      (this.document?.documentRevisions?.length > 1 &&
        !this.latestSealedRevision.viewedByRecipient) ||
      this.waitingToShowReviewModal
    );
  }

  toggleShowVideoReminder(show: boolean) {
    this.showVideoReminder = show;
  }

  openEngageVideoAutomatic() {
    if (
      this.recipientFirstOpen &&
      this.document &&
      this.document.status !== DocumentStatus.Rejected &&
      this.document.status !== DocumentStatus.Lost &&
      this.document.isVideo
    ) {
      this.isEngageVideoOpen = true;
    }
  }

  handleImageLoaded() {
    this.pageImageLoaded = true;
    this.setScrollToBottomListener();
  }

  setScrollToBottomListener() {
    if (
      this.isPreview ||
      this.recipient.status === RecipientStatus.Reviewed ||
      this.recipient.status === RecipientStatus.Signed ||
      this.recipient.status === RecipientStatus.Approved
    ) {
      return;
    }
    this.checkScrolledToBottom();
    window.addEventListener('scroll', this.checkScrolledToBottom, { passive: true });
  }

  handleToggleChat() {
    if (this.chatSystemMessageOpen) {
      this.actionSetChatSystemMessageOpen(false);
    }
    this.actionSetIsChatOpen(!this.isChatOpen);
  }

  handleUpdateRecipientStatus(status: RecipientStatus) {
    this.setRecipientStatus({ status });
  }

  handleUpdateFocusedRequiredId(focusedRequiredId: string) {
    if (this.focusedRequiredId === focusedRequiredId) {
      this.setFocusedRequiredId(null);
      this.$nextTick(() => {
        this.setFocusedRequiredId(focusedRequiredId);
      });
    } else {
      this.setFocusedRequiredId(focusedRequiredId);
    }
  }

  handleClickSignField() {
    if (
      [RecipientStatus.Viewed, RecipientStatus.Reviewed].includes(this.recipient.status) &&
      this.recipient.role === RecipientRole.Signer
    ) {
      this.handleToggleSigningModal(true);
    }
  }

  async trackNodeClick(tracking: Partial<NodeTrackingPayload>) {
    if (this.trackingDisabled) {
      return;
    }
    const payload = {
      ...tracking,
      revision: this.latestSealedRevision.revision,
      type: TrackingType.NodeClick,
    };
    try {
      await TrackingService.trackEditor([], [payload as NodeTrackingPayload]);
    } catch (_) {
      console.log(`Failed to track click for node with id ${payload.nodeId}`);
    }
  }

  handleVideoIntro() {
    this.isEngageVideoOpen = true;
  }

  handleCurrentPages(pageIds: string[]) {
    this.pagesInViewport = this.document.pages.filter((page: DocumentPage) =>
      pageIds.find(pageId => pageId === page.id)
    );
  }

  handleToggleMenu() {
    this.showMainMenu = !this.showMainMenu;
    document.body.style.overflow = this.showMainMenu ? 'hidden' : '';
  }

  handleUpdateField({ fieldId, value }: { fieldId: string; value: string }) {
    this.actionUpdateFieldValue({ fieldId, value });
  }

  handleUpdatePageWidth(offsetWidth: number) {
    this.updatePageWidth(offsetWidth);
  }

  handleToggleUploadAttachmentModal(
    payload: { attachmentId: string; name: string },
    show: boolean
  ) {
    if (show) {
      this.uploadAttachmentData = {
        id: payload.attachmentId,
        name: payload.name,
        show,
      };
    } else {
      this.uploadAttachmentData = {
        id: '',
        name: '',
        show,
      };
    }
  }

  handleAttachmentUploaded() {
    this.actionLoadDocumentAttachments();
    this.handleToggleUploadAttachmentModal(null, false);
  }

  resetInteractionTimer(): void {
    if (this.interactionTimer) {
      clearTimeout(this.interactionTimer);
      this.interactionTimer = null;
    }
    this.userIsInactive = false;
    this.interactionTimer = setTimeout(() => {
      this.userIsInactive = true;
    }, TrackingConstants.idleInteractionInterval);
  }

  handleCloseSystemMessage() {
    this.actionSetChatSystemMessageOpen(false);
  }

  handleReload() {
    window.location.reload();
  }

  get isAutoComment(): boolean {
    if (this.document.isAutoComment === -1) {
      return !!this.entity.isAutoComment;
    }

    return !!this.document.isAutoComment;
  }

  get isSigningForward(): boolean {
    return !!this.document.isSigningForward;
  }

  automaticChatMessage() {
    if (!this.recipientFirstOpen) {
      return;
    }
    setTimeout(() => {
      if (this.isAutoComment) {
        this.actionAutoComment();
      } else {
        this.actionSetChatSystemMessageOpen(true);
      }
      this.setRecipientFirstOpen(false);
    }, 10000);
  }

  async loadData() {
    await this.loadDocument(this.documentId);
    await this.loadEditorRecipientInput();
    await this.loadPartiallySignedFields();
    await this.loadStripe();
    await this.loadAuthorizeNet();
    if (this.getterVideoReminder) {
      this.toggleShowVideoReminder(true);
    } else {
      this.openEngageVideoAutomatic();
    }
    await this.loadFields();
    await this.actionLoadChat();
    if (this.document && !this.document.isVideo) {
      this.automaticChatMessage();
    }
  }

  async addPusherSubscriptions() {
    this.documentPusherChannel = await pusherClient.subscribe(
      ChannelType.Document,
      this.documentId
    );
    this.recipientPusherChannel = await pusherClient.subscribe(
      ChannelType.Recipient,
      this.recipientId
    );

    pusherClient.listen(
      this.recipientPusherChannel,
      PusherEvent.DownloadDocumentResponse,
      ({ url }: { url: string }) => {
        if (this.isPrinting) {
          this.prepareForPrint(url);
        } else if (this.isDownloading) {
          this.handleDownloadComplete(url);
        }
        this.actionDownloadComplete();
      }
    );
    pusherClient.listen(
      this.documentPusherChannel,
      PusherEvent.Sealed,
      (sealed: { documentId: string; entityId: string; revision: number }) => {
        if (sealed) {
          this.handleNewRevisionPushed(reviewTimerDuration);
        }
      }
    );
    pusherClient.listen(
      this.documentPusherChannel,
      PusherEvent.DocumentUpdated,
      () => (this.showDocumentUpdatedPromptBar = true)
    );
    pusherClient.listen(this.documentPusherChannel, PusherEvent.Comment, () => {
      this.actionLoadChat();
    });
    pusherClient.listen(this.documentPusherChannel, PusherEvent.Signed, async () => {
      this.resetSigningState();
      await this.actionLoadAfterSign();
      this.loadPartiallySignedFields();
      setTimeout(() => {
        this.handleToggleStripe(true);
        this.handleToggleAuthorizeNet(true);
      }, 3000);
    });
  }

  handleDownloadComplete(url: string): void {
    this.sendEventLog({ event: DocumentEvent.Downloaded });
    const newWindow: Window = window.open(url, '_blank');
    if (isPopupBlocked(newWindow)) {
      this.handleDownloadCompleteFallback(url);
    }
  }

  handleDownloadCompleteFallback(url: string): void {
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  handleNewRevisionPushed(timerDuration: number) {
    this.showRevisionPromptBar = true;
    this.startForcedReviewTimer(timerDuration);
    this.waitingToShowReviewModal = true;
    setTimeout(() => {
      if (this.waitingToShowReviewModal) {
        this.hideModals();
        this.loadDocumentRevisions();
        this.waitingToShowReviewModal = false;
        this.showReviewChangesModal = true;
      }
    }, timerDuration);
  }

  handleShowReviewChangesModal() {
    this.waitingToShowReviewModal = false;
    this.loadDocumentRevisions();
    this.showRevisionPromptBar = false;
    this.showReviewChangesModal = true;
  }

  async handleReviewChanges() {
    this.forcedReviewTimer = 20;
    this.loadDocumentRevisions();
    if (!this.latestSealedRevision.viewedByRecipient) {
      if (!this.isPreview) {
        await this.setRevisionViewed(this.latestSealedRevision.revision);
      }
      this.loadData();
    }
    this.showReviewChangesModal = false;
  }

  async handlePartiallySign({ signatureBase64, signatureBase30, nodeId }) {
    await this.checkVerificationStep();
    if (signatureBase30 && this.step.type === ESigningStep.Biometric) {
      await this.verifySignature({ signatureBase64, signatureBase30 });
    }
    await editorViewStore.dispatch(`${namespace}/${EditorViewInputAction.PartiallySignField}`, {
      signature: signatureBase64,
      nodeId: nodeId,
    });
    this.loadPartiallySignedFields();
    this.actionUpdateRecipients();
  }

  startForcedReviewTimer(duration: number) {
    let timeLeft = duration / 1000;
    const timer = setInterval(() => {
      if (timeLeft === 0 || !this.waitingToShowReviewModal) {
        clearInterval(timer);
      } else {
        timeLeft -= 1;
      }
      this.setForcedReviewTimer(timeLeft);
    }, 1000);
  }

  setForcedReviewTimer(timeLeft: number) {
    this.forcedReviewTimer = timeLeft;
  }

  hideModals() {
    this.showSigningModal = false;
    this.showInviteModal = false;
    this.showApproveModal = false;
    this.showStripeModal = false;
    this.showAuthorizeNetModal = false;
    this.showRecipientsModal = false;
    this.showRevisionPromptBar = false;
  }

  created() {
    this.hideModals();
  }

  async mounted() {
    window.addEventListener('blur', () => (this.userIsInactive = false));
    window.addEventListener('focus', () => (this.userIsInactive = false));
    window.addEventListener('mousemove', this.debouncedResetInteractionTimer, true);
    window.addEventListener('scroll', this.debouncedResetInteractionTimer, true);
    window.addEventListener('afterprint', this.printPrompt);

    if (this.isPreview) {
      await this.loadPreviewData();
    } else {
      await this.loadData();
      this.resetInteractionTimer();
    }
    this.checkBrowserSupport();
  }

  beforeDestroy() {
    window.removeEventListener('blur', () => (this.userIsInactive = false));
    window.removeEventListener('focus', () => (this.userIsInactive = false));
    window.removeEventListener('mousemove', this.debouncedResetInteractionTimer, true);
    window.removeEventListener('scroll', this.debouncedResetInteractionTimer, true);
    window.removeEventListener('afterprint', this.printPrompt);
    window.removeEventListener('scroll', this.checkScrolledToBottom);
  }

  async handleSelect(type: SidebarOptionType) {
    switch (type) {
      case SidebarOptionType.Recipient: {
        this.handleOpenRecipients();
        break;
      }
      case SidebarOptionType.Chat: {
        this.handleToggleChat();
        break;
      }
      case SidebarOptionType.Invite: {
        this.handleToggleInviteModal(true);
        break;
      }
      case SidebarOptionType.Download: {
        this.downloadDocument();
        break;
      }
      case SidebarOptionType.Print: {
        this.isPrinting = true;
        this.actionDownload();
        break;
      }
      case SidebarOptionType.Call: {
        this.handleOpenPhoneModal();
        break;
      }
      case SidebarOptionType.Reject: {
        this.toggleReject(true);
        break;
      }
      case SidebarOptionType.Help: {
        window.open(
          'https://help.getaccept.com/en/articles/4175027-issues-related-to-document',
          '_blank'
        );
        break;
      }
      default: {
        break;
      }
    }
  }

  async downloadDocument() {
    if (this.document.status === DocumentStatus.Signed) {
      await this.actionGetPdfUrl();
      this.handleDownloadComplete(this.pdfUrl);
    } else if (!this.isDownloading) {
      this.actionDownload();
    }
  }

  prepareForPrint(printUrl: string) {
    const req = new XMLHttpRequest();
    req.open('GET', printUrl, true);
    req.responseType = 'blob';
    req.onload = this.printDocument;
    req.send();
  }

  printDocument({ target }: ProgressEvent) {
    const blob = (target as XMLHttpRequest).response;
    const dataUrl = window.URL.createObjectURL(blob);

    try {
      printJS(dataUrl);
      this.sendEventLog({ event: DocumentEvent.Printed });
    } catch (e) {
      this.toast.info(this.$t('printer-not-found'));
    }
    this.isPrinting = false;
  }

  printPrompt() {
    this.toast.info(this.$t('please-use-print-button'));
  }

  sendMessage(text: string): void {
    this.actionAddComment(text);
  }

  checkBrowserSupport() {
    this.showBrowserPrompt = !new RegExp(supportedBrowsersRegExp).test(navigator.userAgent);
  }

  hideBrowserPrompt() {
    this.showBrowserPrompt = false;
  }

  handleOpenRecipients() {
    this.showRecipientsModal = true;
  }

  handleOpenPhoneModal() {
    this.showPhoneModal = true;
  }

  handleClosePhoneModal() {
    this.showPhoneModal = false;
  }

  handleCloseRecipientsModal() {
    this.showRecipientsModal = false;
  }

  handleCloseEngageVideo() {
    this.automaticChatMessage();
    this.isEngageVideoOpen = false;
  }

  handleToggleStripe(visible: boolean) {
    if (this.shouldPopStripe) {
      this.showSigningModal = false;
      this.showStripeModal = visible;
    }
  }

  handleToggleAuthorizeNet(visible: boolean) {
    if (this.authorizeNetIntegration && !!this.document.value) {
      this.showSigningModal = false;
      this.showAuthorizeNetModal = visible;
    }
  }

  async trackVideo({ id, viewDuration }: { id: string; viewDuration: number }) {
    if (this.trackingDisabled) {
      return;
    }
    try {
      await TrackingService.trackVideo(id, viewDuration);
    } catch (_) {
      console.log(`Failed to track video with id ${id}`);
    }
  }

  handleAttachmentView(id: string) {
    this.setAttachmentView(id);
  }

  toggleReject(open: boolean) {
    this.showRejectModal = open;
  }

  handleToggleSigningModal(open: boolean) {
    if (this.waitingToShowReviewModal) {
      this.handleShowReviewChangesModal();
      return;
    }
    this.showSigningModal = open;
  }

  handleToggleApproveModal(open: boolean) {
    this.showApproveModal = open;
  }

  handleToggleInviteModal(open: boolean) {
    this.showInviteModal = open;
    if (!open) {
      this.actionSetForwardStatus(false);
    }
  }

  handleApproveDocument() {
    this.actionApproveDocument();
  }

  handleInviteRecipient(recipientInfo: InviteRecipientInfo) {
    this.actionForwardToRecipient(recipientInfo);
  }

  checkScrolledToBottom() {
    if (
      this.isPreview ||
      this.recipient.status === RecipientStatus.Reviewed ||
      this.recipient.status === RecipientStatus.Signed ||
      this.recipient.status === RecipientStatus.Approved
    ) {
      return;
    }
    if (this.hasScrolledToBottom()) {
      this.handleUpdateRecipientStatus(RecipientStatus.Reviewed);
      window.removeEventListener('scroll', this.checkScrolledToBottom);
    }
  }

  hasScrolledToBottom(): boolean {
    const scrollPosition: number = Math.ceil(window.scrollY);
    const windowHeight: number = window.innerHeight;
    const documentHeight: number = document.getElementById('document-content-container')
      .offsetHeight;
    return (
      SigningHelper.isFullDocumentHeightVisible(windowHeight, documentHeight) ||
      SigningHelper.hasScrolledToBottom(scrollPosition, windowHeight, documentHeight)
    );
  }

  handleInitialsSubmit(initials: string) {
    this.addInitials({ initials, fieldId: this.selectedInitialFieldId });
  }

  handleInitialsCancel() {
    this.setSelectedInitialFieldId('');
  }

  handleClickInitialsField(fieldId: string) {
    if (!this.initials || this.isFieldVerified(fieldId)) {
      this.setSelectedInitialFieldId(fieldId);
      return;
    }
    this.addVerifiedInitialFieldId(fieldId);
  }

  isFieldVerified(fieldId: string): boolean {
    return this.verifiedInitialFieldIds.includes(fieldId);
  }
}
